import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const styles = {
  card: {
    height: '100%',
    minHeight: '10em',
  },
  row: {
    flexGrow: 1,
    padding: '1rem 1.25rem',
  },
  col: {
    fontSize: '2.25em',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  iconCol: {
    alignItems: 'flex-end',
  },
  footer: {
    textAlign: 'left',
    fontSize: '0.9em',
    height: '30%',
    padding: '0.75rem 1rem',
  },
};

const formatGHGValue = (val) => {
  if (val > 1e8) {
    return (
      (val / 1e8).toLocaleString('en-US', {
        maximumFractionDigits: 2,
      }) + ' B'
    );
  } else if (val > 1e6) {
    return (
      (val / 1e6).toLocaleString('en-US', {
        maximumFractionDigits: 2,
      }) + ' M'
    );
  } else {
    return val.toLocaleString('en-US', {
      maximumFractionDigits: 2,
    });
  }
};

const WidgetInfo = ({ title, value, icon, iconColor }) => (
  <Card style={styles.card}>
    <Row style={styles.row}>
      <Col xs={9} style={styles.col}>
        {value ? formatGHGValue(value) : 0}
      </Col>
      <Col xs={3} style={{ ...styles.col, ...styles.iconCol }}>
        <FontAwesomeIcon style={{ color: iconColor }} icon={icon} />
      </Col>
    </Row>
    <Card.Footer style={styles.footer}>{title}</Card.Footer>
  </Card>
);

export default WidgetInfo;
